(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  const headerSizeObserver = new ResizeObserver((entries) => {
    for (const entry of entries) {
      document.documentElement.style.setProperty(
        '--site-header-height',
        `${entry.target.getBoundingClientRect().height}px`,
      );
    }
  });
  function observeHeaderSize(scope) {
    scope.querySelectorAll('.site-header').forEach((header) => {
      document.documentElement.style.setProperty(
        '--site-header-height',
        `${header.getBoundingClientRect().height}px`,
      );
      headerSizeObserver.observe(header);
    });
  }
  observeHeaderSize(document);
  document.addEventListener('shopify:section:load', (event) => {
    observeHeaderSize(event.target);
  });
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('.site-header').forEach((header) => {
      headerSizeObserver.unobserve(header);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-contact"]) return;
  try {
    
  function focusContactFeedback(scope) {
    const feedback = scope.querySelector('.contact-page [data-contact-feedback]');
    if (feedback) feedback.focus();
  }
  focusContactFeedback(document);
  document.addEventListener('shopify:section:load', (event) => focusContactFeedback(event.target));

  } catch(e) { console.error(e); }
})();
})();
